/**
 * i18next configuration
 *
 * Side-effect import -- initialises i18next on import.
 * All translation files are statically bundled (no async loading).
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import enCommon from './locales/en/common.json'
import enAuth from './locales/en/auth.json'
import enNav from './locales/en/nav.json'
import enErrors from './locales/en/errors.json'
import enAdmin from './locales/en/admin.json'
import enCases from './locales/en/cases.json'
import enSettings from './locales/en/settings.json'
import enEvidence from './locales/en/evidence.json'
import enHistory from './locales/en/history.json'
import enAnalysis from './locales/en/analysis.json'
import enQc from './locales/en/qc.json'

import deCommon from './locales/de/common.json'
import deAuth from './locales/de/auth.json'
import deNav from './locales/de/nav.json'
import deErrors from './locales/de/errors.json'
import deAdmin from './locales/de/admin.json'
import deCases from './locales/de/cases.json'
import deSettings from './locales/de/settings.json'
import deEvidence from './locales/de/evidence.json'
import deHistory from './locales/de/history.json'
import deAnalysis from './locales/de/analysis.json'
import deQc from './locales/de/qc.json'

const LANGUAGE_STORAGE_KEY = 'evidenx_language'

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      auth: enAuth,
      nav: enNav,
      errors: enErrors,
      admin: enAdmin,
      cases: enCases,
      settings: enSettings,
      evidence: enEvidence,
      history: enHistory,
      analysis: enAnalysis,
      qc: enQc,
    },
    de: {
      common: deCommon,
      auth: deAuth,
      nav: deNav,
      errors: deErrors,
      admin: deAdmin,
      cases: deCases,
      settings: deSettings,
      evidence: deEvidence,
      history: deHistory,
      analysis: deAnalysis,
      qc: deQc,
    },
  },
  lng: localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? 'en',
  fallbackLng: 'en',
  fallbackNS: 'common',
  ns: [
    'common',
    'auth',
    'nav',
    'errors',
    'admin',
    'cases',
    'settings',
    'evidence',
    'history',
    'analysis',
    'qc',
  ],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false,
  },
})

export { LANGUAGE_STORAGE_KEY }

export { default } from 'i18next'
